import { store, getContext, getElement } from '@wordpress/interactivity';
interface ServerState {
	activeDrawerId: string | null;
	isDrawerActive: boolean;
	drawerAriaModal: string | null;
	openButtonRef: HTMLElement | null;
	isNestedDrawerActive: boolean;
	activeNestedDrawerSlug: string | null;
	allCategories: any;
}

type buttonContext = {
	id: string;
};
type drawerContext = {
	id: null | string;
	openButtonRef: HTMLElement | null | undefined;
	closeButtonRef: HTMLElement | null | undefined;
};
type topLevelCategoryContext = {
	id: number;
	name: string;
	slug: string;
	parent: number;
	openNestedButtonRef: HTMLElement | null | undefined;
	showClosingAnimation: boolean;
};

const getTypedButtonContext = getContext<buttonContext>;
const getTypedDrawerContext = getContext<drawerContext>;
const getTypedTopLevelCategoryContext = getContext<topLevelCategoryContext>;

const wpSiteBlocks = document.querySelector('.wp-site-blocks');

const storeDef = {
	state: {
		get isScrimActive(): boolean {
			return state.activeDrawerId !== null;
		},

		get isDrawerActive() {
			const ctx = getTypedDrawerContext();
			return ctx.id === state.activeDrawerId;
		},

		get drawerAriaModal() {
			const ctx = getTypedDrawerContext();
			return ctx.id === state.activeDrawerId ? 'true' : null;
		},

		get isNestedDrawerActive() {
			const ctx = getTypedTopLevelCategoryContext();
			return ctx.slug === state.activeNestedDrawerSlug;
		},
	},

	actions: {
		toggleDrawerOpen: (e) => {
			const { ref } = getElement();
			const ctx = getTypedButtonContext();
			const click = e.type === 'click';
			if (!click) {
				return;
			}
			state.activeDrawerId = ctx.id;
			state.openButtonRef = ref;
			wpSiteBlocks?.setAttribute('inert', '');
			document.documentElement.classList.add('has-modal-open');
		},

		toggleDrawerClose: (e) => {
			const click = e.type === 'click';
			if (!click) {
				return;
			}
			callbacks.closeDrawer();
		},

		handleDrawerKeydown: (e) => {
			if (e.key !== 'Escape') {
				return;
			}
			callbacks.closeDrawer();
		},

		toggleNestedDrawerOpen: (e) => {
			const { ref } = getElement();
			const ctx = getTypedTopLevelCategoryContext();
			const click = e.type === 'click';
			if (!click) {
				return;
			}
			state.activeNestedDrawerSlug = ctx.slug;
			ctx.openNestedButtonRef = ref;
			ctx.showClosingAnimation = true;
		},

		toggleNestedDrawerClose: (e) => {
			const ctx = getTypedTopLevelCategoryContext();
			const click = e.type === 'click';
			if (!click) {
				return;
			}
			state.activeNestedDrawerSlug = null;
			if (!ctx.openNestedButtonRef) {
				return;
			}
			ctx.openNestedButtonRef.focus();
		},
	},

	callbacks: {
		handleDrawerOpen: () => {
			if (!state.isDrawerActive) {
				return;
			}
			const { ref } = getElement();
			const closeBtn = ref?.querySelector(
				"button[aria-label='Close dialog']"
			);
			closeBtn?.focus();
		},

		closeDrawer: () => {
			state.activeDrawerId = null;
			state.activeNestedDrawerSlug = null;
			wpSiteBlocks?.removeAttribute('inert');
			state.openButtonRef?.focus();
			document.documentElement.classList.remove('has-modal-open');
		},

		handleNestedDrawerOpen: () => {
			if (!state.isNestedDrawerActive) {
				return;
			}
			const { ref } = getElement();
			const closeBtn = ref?.querySelector('.nested-drawer-close-button');

			setTimeout(() => {
				// move focus to inside the inner panel after the opening animation is triggered
				closeBtn?.focus();
			}, 100);
		},
	},
};

type Store = ServerState & typeof storeDef;
const { state, actions, callbacks } = store<Store>(
	'navigation-drawer',
	storeDef
);
